import { render, staticRenderFns } from "./modalOT.vue?vue&type=template&id=1c9f339c&"
import script from "./modalOT.vue?vue&type=script&lang=js&"
export * from "./modalOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports